import { render, staticRenderFns } from "./ListDealsItem.vue?vue&type=template&id=4fa6f44b&"
import script from "./ListDealsItem.vue?vue&type=script&lang=js&"
export * from "./ListDealsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListDealsItem.vue"
export default component.exports